import { Redirect } from 'expo-router';

import { CheckoutV2ExperimentLoading } from 'experiments/checkout-v2/checkout-v2-experiment-loading';
import { Payment } from 'experiments/checkout-v2/control/pages/cart/payment/order-payment/payment';
import { useCheckoutV2ExperimentGate } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { routes } from 'utils/routing';

export default function CartPaymentPage() {
  const { isReady, isTreatment } = useCheckoutV2ExperimentGate();

  if (!isReady) {
    return <CheckoutV2ExperimentLoading />;
  }

  if (isTreatment) {
    return <Redirect href={routes.cartCheckout} />;
  }

  return <Payment />;
}
